import React, { useEffect, useState } from 'react';
import { Center, Text, Circle, VStack, Box, useTheme } from 'native-base';
import GoBackButton from '../content/common/GoBackButton';
import { useAuthState } from '../../context/auth';
import { useEnvState } from '../../context/env';
import { overviewAPI } from '../../context/overview';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { faCertificate } from '@fortawesome/pro-regular-svg-icons';
const BadgeScreen = ({
  navigation,
  route
}) => {
  const theme = useTheme(),
    {
      colors
    } = theme;
  const {
    badgeId
  } = route.params;
  const authState = useAuthState();
  const envState = useEnvState();
  const {
    api_key
  } = authState;
  const [badgeItem, setBadgeItem] = useState({});
  const {
    description,
    long_description,
    name
  } = badgeItem;
  const symbols = [{
    string: ':heart:',
    symbol: '❤️'
  }];
  useEffect(() => {
    getBadgeData(badgeId);
  }, [badgeId]);
  const getBadgeData = async badgeId => {
    const response = await overviewAPI.getBadge(envState.base_url, api_key, badgeId);
    if (response && response.badge) {
      const badge = response.badge;
      setBadgeItem(badge);
    }
  };
  const displayText = text => {
    if (text) {
      if (checkForSymbols(text)) {
        for (let i = 0; i < symbols.length; i++) {
          text = text.replaceAll(symbols[i].string, symbols[i].symbol);
        }
      }
    }
    return text;
  };
  const checkForSymbols = text => {
    if (text) {
      for (let i = 0; i < symbols.length; i++) {
        if (text.includes(symbols[i].string)) {
          return true;
        }
      }
    }
    return false;
  };
  return badgeItem ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GoBackButton, {
    navigation: navigation
  }), /*#__PURE__*/React.createElement(Box, {
    w: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1
  }, /*#__PURE__*/React.createElement(Center, {
    w: '90%'
  }, /*#__PURE__*/React.createElement(VStack, {
    space: 6,
    justifyContent: 'center',
    alignItems: 'center'
  }, /*#__PURE__*/React.createElement(Circle, {
    bg: colors.badge.circle,
    size: '12'
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faCertificate,
    color: colors.badge.icon
  })), /*#__PURE__*/React.createElement(Text, null, "Badge name: ", name), /*#__PURE__*/React.createElement(Text, null, "Description: ", description), /*#__PURE__*/React.createElement(Text, null, displayText(long_description)))))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GoBackButton, {
    navigation: navigation
  }), /*#__PURE__*/React.createElement(Center, null, /*#__PURE__*/React.createElement(Text, null, "Data not found")));
};
export default BadgeScreen;
//# sourceMappingURL=BadgeScreen.js.map